export default {
  async 'cabinet/loadPageData'({ commit, dispatch }, url) {
    try {
      commit('global/loaderStart');
      const { status, data } = await axios.get(url, { params: { api: 'y' } });

      if (status !== 200) throw `bad request response status: ${status}`;

      commit('cabinet/setState', data);
      dispatch('footerMiniBanner/refreshMiniBanner', url);
      dispatch('happyBirthdayBanner/refresh', url);
      commit('global/loaderStop');
    } catch (err) {
      console.error(err);
    }
  },
  async 'cabinet/showMore'({ state, commit }, url) {
    try {
      commit('global/loaderStart');
      const { status, data } = await axios.get(url, { params: { api: 'y' } });

      if (status !== 200) throw `bad request response status: ${status}`;

      const newData = {
        ...data,
        items: [...state.data.items, ...data.items],
      };

      commit('cabinet/setState', newData);
      commit('global/loaderStop');
    } catch (err) {
      console.error(err);
    }
  },
  async 'cabinet/changeSKU'({ state, commit }, { result, size }) {
    try {
      commit('global/loaderStart');
      const url = size.detailPage;
      const { status, data } = await axios.get(url, { params: { api: 'y' } });

      if (status !== 200) throw `bad request response status: ${status}`;

      const newData = {
        ...state.data,
        items: state.data.items.map((el) => {
          if (el.id === result.id) {
            return data.product;
          }
          return el;
        }),
      };

      commit('cabinet/setState', newData);
    } catch (err) {
      console.error(err);
    } finally {
      commit('global/loaderStop');
    }
  },
  async 'cabinet/deleteViewedProducts'({ state, commit }) {
    try {
      const { path, action } = state.data.routes.deleteAll;
      const { status, data } = await axios.post(path, { action });

      if (status !== 200) throw `bad request response status: ${status}`;

      commit('cabinet/setState', { ...state.data, items: data.items });
    } catch (err) {
      console.error(err);
    }
  },
  async 'cabinet/deleteViewedProductById'({ state, commit }, id) {
    try {
      const { path, action } = state.data.routes.deleteProductById;
      const { status, data } = await axios.post(path, { action, id });

      if (status !== 200) throw `bad request response status: ${status}`;

      commit('cabinet/setState', { ...state.data, items: data.items });
    } catch (err) {
      console.error(err);
    }
  },
  async 'cabinet/getCreateClubCard'({ state, commit }, formData) {
    try {
      const { path, action } = state.data.routes.getCreateClubCard;
      formData.set('action', action);
      const { status } = await axios.post(path, formData);

      if (status !== 200) throw `bad request response status: ${status}`;
    } catch (err) {
      console.error(err);
    }
  },

  async 'cabinet/updatePageData'({ state, commit }, payload) {
    try {
      commit('global/loaderStart');
      const { data } = await axios.get(window.location.href, {
        params: {
          api: 'Y',
          ...payload,
        },
      });

      commit('cabinet/setState', data);
    } catch (err) {
      console.error(err);
    } finally {
      commit('global/loaderStop');
    }
  },
  // addresses methods
  async 'cabinet/updateUserDeliveryAddress'({ state, commit, dispatch }, formData) {
    try {
      commit('global/loaderStart');
      const { path, action } = state.data.routes.updateUserDeliveryAddress;

      formData.set('action', action);

      const { status, data } = await axios.post(path, formData);
      await dispatch('cabinet/updatePageData');
    } catch (error) {
      console.error(error);
    } finally {
      commit('global/loaderStop');
    }
  },
  async 'cabinet/addUserDeliveryAddress'({ state, commit, dispatch }, formData) {
    try {
      commit('global/loaderStart');
      const { path, action } = state.data.routes.addUserDeliveryAddress;
      formData.set('action', action);

      const { status, data } = await axios.post(path, formData);
      await dispatch('cabinet/updatePageData');
    } catch (error) {
      console.error(error);
    } finally {
      commit('global/loaderStop');
    }
  },
  async 'cabinet/removeUserDeliveryAddress'({ state, commit, dispatch }, id) {
    try {
      commit('global/loaderStart');
      const { path, action } = state.data.routes.removeUserDeliveryAddress;

      const { status, data } = await axios.post(path, {
        action,
        id,
      });

      await dispatch('cabinet/updatePageData');
    } catch (error) {
      console.error(error);
    } finally {
      commit('global/loaderStop');
    }
  },
  // addresses methods end
};
